const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20shadowy%20figures%20meeting%20in%20a%20luxury%20hotel%20lobby%20at%20night%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20amber%20accents%2C%20cinematic%20film%20noir%20style%2C%20deep%20shadows%2C%20editorial%20photography&width=800&height=500&seq=card-01-2026&orientation=landscape',
    title: '顶流艺人深夜密会曝光，实锤照片流出引发全网震动',
    excerpt: '据知情人士透露，某当红一线明星近期频繁出入某高端酒店，与神秘异性同行画面被独家捕获。照片显示二人举止亲密，据悉对方并非圈内人士。该消息一经传播，相关话题迅速登顶各大社交平台热搜榜首。',
    time: '3小时前',
    views: '128万',
    tag: '娱乐圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20interior%20with%20scattered%20financial%20documents%20on%20a%20desk%2C%20dramatic%20overhead%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20red%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20cinematic%20composition&width=800&height=500&seq=card-02-2026&orientation=landscape',
    title: '知名企业涉嫌财务造假，内部审计文件遭匿名泄露',
    excerpt: '一份据称来自某上市公司内部审计部门的文件近日在网络上流传，文件详细记录了该公司近三年来的财务异常数据。多位财务分析师对文件真实性表示高度关注，相关监管部门已介入调查。',
    time: '6小时前',
    views: '96万',
    tag: '商业圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20studio%20setup%20with%20ring%20light%20and%20microphone%2C%20dramatic%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20golden%20amber%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20cinematic%20photography&width=800&height=500&seq=card-03-2026&orientation=landscape',
    title: '头部带货主播涉嫌虚假宣传，消费者集体维权索赔过亿',
    excerpt: '多位消费者联合发声，指控某粉丝量过千万的带货主播在直播中夸大产品功效，实际使用效果与宣传严重不符。目前已有超过500名消费者加入维权群，索赔金额累计突破亿元大关。',
    time: '9小时前',
    views: '85万',
    tag: '网红圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20film%20production%20office%20with%20storyboards%20on%20the%20wall%2C%20dramatic%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20red%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20cinematic%20composition&width=800&height=500&seq=card-04-2026&orientation=landscape',
    title: '影视公司内部派系斗争白热化，多名高管接连请辞',
    excerpt: '某老牌影视制作公司近期人事动荡不断，短短一个月内已有三位副总裁级别高管递交辞呈。消息人士称公司内部两大派系围绕重点项目主导权展开激烈争夺，多个已立项作品面临停摆风险。',
    time: '12小时前',
    views: '72万',
    tag: '娱乐圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20sports%20arena%20interior%20empty%20at%20night%2C%20dramatic%20stadium%20lighting%2C%20mysterious%20atmosphere%2C%20golden%20amber%20and%20red%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20cinematic%20photography&width=800&height=500&seq=card-05-2026&orientation=landscape',
    title: '国际赛事裁判收受贿赂丑闻，多国选手联合实名举报',
    excerpt: '一项国际顶级赛事的裁判团队被曝涉嫌收受巨额贿赂操纵比赛结果。来自五个国家的十余位参赛选手联名提交举报材料，指控特定裁判在多场关键比赛中做出明显偏向性判罚。',
    time: '18小时前',
    views: '67万',
    tag: '体育圈',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            今日焦点
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            实时追踪全网最火爆的爆料事件，第一时间掌握最新吃瓜动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 2).map((item, i) => (
            <article
              key={i}
              className={`group bg-background-100 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/20 to-transparent"></div>
                <span className="absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded bg-primary-500/80 text-background-50">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-3">{item.excerpt}</p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
          {cardItems.slice(2).map((item, i) => (
            <article
              key={i + 2}
              className="group bg-background-100 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/20 to-transparent"></div>
                <span className="absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded bg-primary-500/80 text-background-50">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.excerpt}</p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}